export const SearchState = {
    FAMILY: 'family',
    PEOPLE: 'people',
    STREETS: 'streets',
    SCHOOL: 'school',

};